module.exports = __webpack_public_path__ + "img/daily.9f20dc5a.png";